import React, { ReactNode } from 'react';

import { FireForecastItem } from './fireForecastItem';
import { FireForecastType } from '../utilities/interfaces';
import styled from 'styled-components';

interface FireForecastInterface {
    forecast: FireForecastType[];
    location: string;
    customHeader: () => ReactNode;
}

export const FireForecast = ({ 
    forecast, 
    location, 
    customHeader 
}: FireForecastInterface) => {
    let headerText = 'FIRE DANGER RISK';
    if (location) {
        headerText += ' FOR';
    }

    return (
        <Container>
            {customHeader && customHeader()} 
            {!customHeader && <Header location={location}>
                {headerText}
                {location?.length > 0 && <span>
                        {location.toUpperCase()}
                    </span>}
                </Header>
            }
            <Content>
                {forecast?.map((item: FireForecastType) => 
                    <FireForecastItem 
                        key={item?.dayOfWeekAbbreviatedLocal}
                        dayOfWeekAbbreviatedLocal={item?.dayOfWeekAbbreviatedLocal}
                        fireRiskIndex={item?.fireRiskIndex}
                        fireRiskDescriptionShort={item?.fireRiskDescriptionShort}
                    />
                )}
            </Content>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    color: #666666;
    font-size: 14px;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 300;
`;

interface HeaderType {
    location: string;
}
const Header = styled.div<HeaderType>`
    border-bottom-width: 1;
    border-bottom-color: #BCBBC1;
    border-bottom-style: solid;
    padding: 8px;
    padding-top: ${({ location }) => location?.length > 0 ? 4 : 8};
    padding-bottom: ${({ location }) => location?.length > 0 ? 4 : 8};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    text-align: center;
    font-size: ${({ location }) => location?.length > 26 ? 14 : 16};
`;

const Content = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 8px;
    padding-bottom: 8px;
    justify-content: space-around;
`;
